import { Container } from "pixi.js";

export class FixedSizeContainer extends Container {
    private readonly fixedWidth: number;
    private readonly fixedHeight: number;

    public constructor(width: number, heigth: number) {
        super();
        this.fixedWidth = width;
        this.fixedHeight = heigth;
    }

    public override calculateBounds(): void {
        this._bounds.clear();
        this._calculateBounds();
        this._bounds.updateID = this._boundsID;
    }

    protected override _calculateBounds(): void {
        this._bounds.addFramePad(0, 0, this.fixedWidth, this.fixedHeight, 0, 0);
    }
}